import useBreakPoinst from '@hooks/useBreakPoinst';
import { Box } from '@mui/material';
import { ReactNode } from 'react';

interface IStatsCardProps {
  icon: ReactNode;
  label: string;
  value: string | number;
}

const StatsCard = ({ icon, label, value }: IStatsCardProps) => {
  const { isPhone } = useBreakPoinst();

  return (
    <Box
      sx={{
        flex: 1,
        minWidth: isPhone ? '100%' : '200px',
        height: '101px',
        borderRadius: '16px',
        padding: '24px',
        background: '#FFFFFF',
        border: '1px solid #EAEDF1',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          justifyContent: 'space-around',
          gap: '8px',
        }}
      >
        <span
          style={{
            fontWeight: 400,
            fontSize: '14px',
            color: '#435363',
          }}
        >
          {label}
        </span>
        <span
          style={{
            fontWeight: 700,
            fontSize: isPhone ? '20px' : '32px',
            color: '#5B3FFF',
          }}
        >
          {value}
        </span>
      </Box>
      {icon}
    </Box>
  );
};

interface IStatsCardsProps {
  cards: IStatsCardProps[];
}

const StatsCards = ({ cards }: IStatsCardsProps) => {
  const { isPhone } = useBreakPoinst();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isPhone ? 'column' : 'row',
        gap: '16px',
        width: '100%',
      }}
    >
      {cards.map((card, index) => (
        <StatsCard key={index} {...card} />
      ))}
    </Box>
  );
};

export default StatsCards;
